// extracted by mini-css-extract-plugin
export default {"container":"PayCancel_container__0sg-t","button":"PayCancel_button__i7Wsr","buttonWord":"PayCancel_buttonWord__SeMbO"};